import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { createApi } from 'ReduxHelpers';
import keyBy from 'Utils/keyBy';
import {
    type LessonForPermissions,
    type UpdateLessonPermissionsParams,
    type UserForLessonPermissions,
} from '../AdminLessonPermissionsTab.types';
import { LESSON_FIELDS, USER_LESSON_PERMISSIONS_FIELDS } from '../constants';

type UsersResponse = { contents: { users: UserForLessonPermissions[] } };
type LessonsResponse = { contents: { lessons: LessonForPermissions[] } };

export const adminLessonPermissionsApi = createApi('adminLessonPermissionsApi', {
    ...getBackRoyalApiBaseConfig('adminLessonPermissionsApi'),
    endpoints: builder => ({
        getUserForLessonPermissions: builder.query<UserForLessonPermissions, string>({
            query: userId => ({
                url: `users/${userId}`,
                params: { 'fields[]': USER_LESSON_PERMISSIONS_FIELDS },
            }),
            transformResponse: (response: UsersResponse) => response.contents.users?.[0],
        }),

        // Every unpublished lesson, archived ones included, as LessonsCtrlBase loaded them. The
        // server returns a lesson once per version that ties on the latest updated_at, so key by id.
        getLessonsForPermissions: builder.query<LessonForPermissions[], void>({
            query: () => ({
                url: 'lessons.json',
                params: { filters: { published: false }, 'fields[]': LESSON_FIELDS },
            }),
            transformResponse: (response: LessonsResponse) => Object.values(keyBy(response.contents.lessons, 'id')),
        }),

        // users_controller#update is a collection route; the id travels in `record`. The server
        // replaces all of the user's roles with the ones sent (process_role_updates).
        updateLessonPermissions: builder.mutation<void, UpdateLessonPermissionsParams>({
            query: ({ record }) => ({ method: 'put', url: 'users.json', body: { record } }),
        }),
    }),
});
